<template>
    <div v-show="showAllDiv" :class="`col-sm-12 test forms-container`"  :style="{ 'border-top': viewPage ? '19px solid #f3f3f4' : '' }">

        <div class="ibox">
            <div class="ibox-title     Forms_checklists_data questions-form-and-checklist"
                 :style="`padding: ${elementStyle}`"  style="padding: 7px 15px 0px;"  :class="[viewPage ? 'padding-new-style-form-adn-checklist' : '']">
                <div class="row m-bottom-10 pad-left-15-mobile-0 pad-right-15-mobile-0" >
                    <!--        Forms & checklists title-->
                    <div class="inline-block m-bottom-10-mobile" style="width: 100%">
                        <div class="drag-tool m-mobile-title">

                            <span class="title_data_mop"  >
                                <div class="inline-block" v-if="viewPage">
                                    <div class="drag-tool">
                                         <span class="select-services-dropdown-title">Forms &amp; checklists</span>
                                         <a>
                                            <svg data-target="#popupi" data-toggle="modal" fill="none" height="20"
                                                 style="fill: #CBCFD3; position:relative; bottom: -4px" viewBox="0 0 20 20"
                                                 width="20" xmlns="http://www.w3.org/2000/svg" @click="infoPopup">
                                                <path
                                                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z"
                                                    fill="#CBCFD3"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                                <div class="inline-block" v-else>
                                <div class="drag-tool">
                                  
                                    </svg>
                                    <span style="margin-left: 6px" >
                                     <span class="select-services-dropdown-title">Forms &amp; checklists</span>
                                    <a>
                                        <svg data-target="#popupi" data-toggle="modal" fill="none" height="20"
                                             style="fill: #CBCFD3; position:relative; bottom: -4px" viewBox="0 0 20 20"
                                             width="20" xmlns="http://www.w3.org/2000/svg" @click="infoPopup">
                                            <path
                                                d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 17H9V15H11V17ZM13.07 9.25L12.17 10.17C11.45 10.9 11 11.5 11 13H9V12.5C9 11.4 9.45 10.4 10.17 9.67L11.41 8.41C11.78 8.05 12 7.55 12 7C12 5.9 11.1 5 10 5C8.9 5 8 5.9 8 7H6C6 4.79 7.79 3 10 3C12.21 3 14 4.79 14 7C14 7.88 13.64 8.68 13.07 9.25Z"
                                                fill="#CBCFD3"></path>
                                        </svg>
                                    </a>
                                </span>
                                </div>
                            </div>
                            <!--            three dots -->
                            </span>
                            <div v-if="viewPage" class="inline float-right">

                                <div class="dropdown" style="float: right;">
                                    <button
                                        v-if="canSeeCustomer || loggedUser.role_id  != 1"
                                        data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false" class="actions-btn  btn btn-default three-dots-btn gh_customer_name dropdown-toggle">
                                        <i class="fa fa-ellipsis-v " style='color:rgba(138, 138, 138,1);font-size: 18px;'></i>
                                    </button>
                                    <ul class="dropdown-menu dropdownActionsMenuCusList pair_of_all_li"
                                        aria-labelledby="photosDropDonwActionsMenu" style="z-index: 99999998; margin-left:-300px;top: 20px"
                                        id="photosActionsMenuByHover">

                                        <li>
                                            <!--:TODO add replicate function -->
                                            <a href="javascript:" data-toggle="modal" data-target="#popupi" @click="openPopup">
                                                Email form
                                            </a>
                                        </li>



                                        <!--                        <li v-if="type == 'booking'">-->
                                        <!--                             <a class="black_color upper" href="javascript:void(0)" data-toggle="modal" data-target="#popupi"  @click="uploadAttachment" ><span class="fa fa-upload"></span> <span>Upload Files</span></a>-->
                                        <!--                        </li>-->


                                    </ul>
                                </div>
                    </div>
                        </div>
                    </div>




                    <QForm v-for="(form,index) of forms" :key="form.form_id" @formsMounted="onFormsMounted"
                       v-model="forms[index]"
                       :date-format="dateFormat"
                       :item-id="itemId"
                       :time-format="timeFormat"
                       :services="services"
                       :s3-path="s3Path"
                       :view-page="viewPage"
                       :check-credential-form-and-check-list ="checkCredentialFormAndCheckList"
                    ></QForm>
                    <br>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {getAvailableForms, changeFollowUp, updateFollowUpDate,changeExpiryDate,updateExpiryDate} from "@/modules/Forms/api"
import {EventBus} from "@/events/event-bus";
export default {
    name: "Forms",
    props: {
        viewPage:false,

        services: {
            type: Array,
            default() {
                return []
            }
        },
       canSeeCustomer: null,
       loggedUser: null,
        submitForms: Function,
        dateFormat: {
            required: true,
            type: String
        },
        timeFormat: {
            required: true,
            type: String
        },
        giftStatus: null,
        itemId:null,
        inquiryId:null,
        expiryDateIsActive:null,
        expiryDate:null,
        followUpDate:null,
        isToFollow:false,
        checkCredentialFormAndCheckList:false,
    },
    data() {
        return {
            forms: [],
            showAllDiv:true,
            bookingStatus: $('#bookingStatus').val() ?? 4,
            whenToDisplayForm: 5,
            elementStyle: '0',
            firstLoadOnView:(this.itemId>0 && !this.inquiryId?1:0),
            contractors: [],
            s3Path:'',
            formsChanged:false,
            shouldShowSaveButton:!this.viewPage,
            formsRenderedCount: 0,
            expiryDateActive: this.expiryDateIsActive,
            toFollow: this.isToFollow,
            expiryDateValue: this.expiryDate,
            followUpDateValue:this.followUpDate == 0 ? null : this.followUpDate,
        }
    },
    computed:{
        servicesData(){
            return [...this.services]
        },
    },
    methods: {
        initialize() {
            getAvailableForms(this.itemId, this.bookingStatus, this.contractors,this.services.map(service => service.service_id),this.whenToDisplayForm,this.firstLoadOnView)
                .then(response => {
                    this.firstLoadOnView = 0;
                    this.forms = response.data.forms
                    if (this.forms.length){
                        this.showAllDiv= true;
                        for (var i = 0; i < this.forms.length; i++) {
                            if(this.itemId){
                                this.forms[i].collapsed = false;
                            }else{
                                this.forms[i].collapsed = true;
                            }
                        }
                    }
                    else{
                            this.showAllDiv= false;
                    }
                })

        },
        onFormsMounted(){
          let vm =this;
             if (this.viewPage && !this.formsChanged && !this.shouldShowSaveButton){

                 this.$nextTick(function () {

                       vm.serviceChanged = true;
                       // window.addEventListener('scroll', function() {
                       //   var viewContainer = document.querySelector('.forms-container');
                       //   var bookingPricingIbox = document.querySelector('.privateNotes_component');
                       //
                       //   // Check if the elements exist
                       //   if (viewContainer && bookingPricingIbox) {
                       //     var viewContainerTop = viewContainer.getBoundingClientRect().top + window.pageYOffset;
                       //     var bookingPricingBottom = bookingPricingIbox.getBoundingClientRect().bottom + window.pageYOffset;
                       //
                       //     var windowScrollTop = window.pageYOffset;
                       //
                       //     if(windowScrollTop >= viewContainerTop && windowScrollTop < bookingPricingBottom) {
                       //       // When the window scroll is between the top of view-container and the bottom of booking-pricing-ibox
                       //       document.getElementById('save_btn_cont').classList.add('fixed-header');
                       //       document.getElementById('save_booking_btn_id').classList.remove('hidden');
                       //       document.querySelector('.service-title').classList.remove('hidden');
                       //       document.querySelector('.service-title span').innerHTML = "Forms & checklists";
                       //
                       //     } else {
                       //       // When the window scroll is outside this range
                       //       document.getElementById('save_btn_cont').classList.remove('fixed-header');
                       //       document.getElementById('save_booking_btn_id').classList.add('hidden');
                       //       document.querySelector('.service-title').classList.add('hidden');
                       //       document.querySelector('.service-title span').innerHTML = "Services";
                       //
                       //     }
                       //   }
                       // });
                       //vm.saveFormAndChecklist();

                 });



                this.formsRenderedCount++;
                if (this.formsRenderedCount === this.forms.length ) {
                    this.shouldShowSaveButton = true;
                }
            }
            },
            infoPopup() {
            window.popupi_alert('Customizable Forms and Checklists for Enhanced Data Accuracy and User Engagement',
                `OctopusPro's Forms and Checklists feature enhances your booking process, offering a blend of efficiency,
                                    adaptability, and thorough data capture. Designed to be accessible both online and offline,
                                    these customizable tools allow for the creation of digital forms and checklists suited to a variety of professional needs.
                                    They include diverse content options like text, photos, videos, signatures, and file uploads, ensuring comprehensive and relevant data collection.
                                    <br><br>
                                    Key settings include Custom Fields for capturing a wide range of data types, Data Validation rules for accuracy,
                                    and Visibility Options to control who sees your forms and checklists.
                                    This ensures precise communication tailored to different user levels like fieldworkers, customers, and office users.
                                     The Display Options allow you to decide when forms appear in the booking process,
                                     including choices like 'Always Displayed', 'Check-In', 'Check-Out', and 'Change Status',
                                     ensuring timely and context-specific data collection. Additionally,
                                     the feature supports PDF Conversion and Sharing for streamlined communication among stakeholders.
                                    <br><br>
                                    Integrating these tools into your workflow not only bolsters productivity and task management but also elevates customer satisfaction and drives organizational
                                     efficiency to new heights. For a deeper dive into harnessing the full potential of forms and checklists, explore our comprehensive user guide at
                                    <a href='https://help.octopuspro.com/forms-checklists-introduction' target='_blank'>https://help.octopuspro.com/forms-checklists-introduction</a>`)
        },
        openPopup() {
            const customerId =  $('#customer_id').val();
            const title = 'Email Forms';
            const url = `/get-canned-responses-form/customer/email/booking/${this.itemId}/${customerId}/forms_and_checklists`;
            window.popupi(title , url);
        },
        shouldInitialize(newServices, oldServices) {
            // Implement logic to determine whether to call initialize
            // For example, check if the length of the array has changed
            //&&this.shouldShowSaveButton
            if(newServices && oldServices ){
                return newServices.length !== oldServices.length;
            }else{
                return false;
            }
        },
        saveFormAndChecklist(){
            this.submitForms();
        },
        initializeExpiryDatePicker() {
      const vm = this;
        $(this.$refs['date']).datepicker({
          todayBtn: "linked",
          todayHighlight: true,
          keyboardNavigation: false,
          forceParse: false,
          calendarWeeks: true,
          autoclose: true,
          format: vm.dateFormat
        }).on('changeDate', function(e) {
          vm.expiryDateValue = e.target.value;
          if (e.target.id === "expiryDate" && vm.viewPage){
            vm.updateExpiryDate(e.target.value);
          }
        });
      },
        initializeFollowUpDatePicker() {
        const vm = this;
        $(this.$refs['followDate']).datepicker({
          todayBtn: "linked",
          todayHighlight: true,
          keyboardNavigation: false,
          forceParse: false,
          calendarWeeks: true,
          autoclose: true,
          format: vm.dateFormat
          // Your datepicker options here
        }).on('changeDate', function(e) {
          vm.followUpDateValue = e.target.value;
          if (e.target.id === "followUpDate" && vm.viewPage){
            vm.updateFollowUpDate(e.target.value);
          }
        });
        // Add any additional logic if needed
      },
        updateFollowUpDate(value){
            let vm = this
            updateFollowUpDate(this.itemId,value).then(response => {
                   if (response.status){
                   $.notify('Follow up date has been updated successfully', 'success')
                   }
            })
        },
        updateExpiryDate(value){
            let vm = this
            updateExpiryDate(this.itemId,value).then(response => {
                   if (response.status){
                   $.notify('Expiry date has been updated successfully', 'success')
                   }
            })
        },
        changeFollowUp(){
            let vm =this;
           changeFollowUp(this.itemId , this.toFollow).then(response => {
               if (response.status){
                   vm.isToFollow = !vm.isToFollow;
                   $.notify('Follow up date has been changed successfully', 'success')
               }
           })
        },
        changeExpiryDate(){
            let vm =this;
            changeExpiryDate(this.itemId , this.expiryDateIsActive).then(response => {
               if (response.status){
                   vm.expiryDateIsActive = !vm.expiryDateIsActive;
                   $.notify('Expiry date has been changed successfully', 'success')
               }
           })
        },
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
              xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
              xWidth = window.innerWidth;

            if (document.body != null)
              xWidth = document.body.clientWidth;

            return xWidth;
        },
        viewPageStyle() {
            return this.viewPage?'background-color: #fff !important;':'';
        },
    },
    mounted() {
        if (this.viewPage){
            // this.add_border_to_main_section='add_border_to_main_section';
        }
      if (this.itemId){

          if(this.getWidth() <= 425) {
            this.elementStyle=" 14px 16px 20px ; ";

          }
          else if(this.getWidth() <= 725) {
            this.elementStyle="0px;";
          }
        else {
            this.elementStyle="5px;";

          }

      }else {
        if(this.getWidth() <= 425) {
          this.elementStyle=" 14px 21px 20px ; ";

        }
        else {
          this.elementStyle="5px ; ";

        }

      }
        this.initialize();
        this.$nextTick(() => {
            let vm = this;
            setTimeout(function (e){
              // Initial initialization
              if (vm.expiryDateActive) {
                vm.initializeExpiryDatePicker();
              }
              if (vm.toFollow) {
                vm.initializeFollowUpDatePicker();
              }
            },2000)

        })

        EventBus.$on('onUpdateFormAndCheckList', () => {
            this.initialize();
        });

        EventBus.$on('onBookingStatusChange', status => {
            this.whenToDisplayForm = 5;
            if (this.giftStatus == status.booking_status_id){
                this.whenToDisplayForm = 6;
            }
            this.bookingStatus = status.booking_status_id;

            this.initialize();
        });
        EventBus.$on('selectContractorChange', (contractor_id,serviceId,clone,index) => {
            this.contractors.push(contractor_id);
            this.initialize();

        });

        EventBus.$on('onCollapseCheckLists',  (number) => {
            let selectedForm = this.forms.filter( form => form.form_id == number)[0];
            if(!selectedForm.collapsed){
                $('[data-target="#forms_checklists_toggle_'+number+'"]').click()
                selectedForm.collapsed = true;
            }
        }),
        EventBus.$on('onChangeCheckListStatus',  (form_id , status) => {
            let selectedForm = this.forms.filter( form => form.form_id == form_id)[0];
            selectedForm.collapsed = status;
        })
    },
    watch: {
        servicesData: {
            handler(newVal, oldVal) {
                if (this.shouldInitialize(newVal, oldVal)) {
                    this.initialize();
                }
            },
            deep: true,
            immediate: true
        },
        forms: {
            handler(newVal, oldVal) {
                this.$emit('input', newVal)

                if (!this.formsChanged && this.shouldShowSaveButton && this.viewPage){
                    this.formsChanged = true;
                }
            },
            deep: true,
            immediate: true
        },
      // Watcher for expiryDateActive
      expiryDateActive(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            this.initializeExpiryDatePicker();
              this.changeExpiryDate()
          })
        }else{
                this.changeExpiryDate()
        }
      },
      // Watcher for toFollow
      toFollow(newValue) {
        if (newValue) {
          this.$nextTick(() => {
            this.initializeFollowUpDatePicker();
              this.changeFollowUp();
          })
        }else {
          this.changeFollowUp();
        }
      },
    },
}
</script>

<style scoped>


.add_border_to_main_section{
    border-top: #f3f3f4 19px solid;
}
.ibox-content{
  padding:  5px 5px 5px 0px;
}
.title_data_mop{
  margin-bottom: 20px;
}
.drag-tool m-mobile-title{
    margin-bottom: 20px;
}
.Forms_checklists_data{

  font-size: 13px !important;
  font-weight: 100;
  padding: 5px;
  border-color: transparent;
    color: #2E4051 !important;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    }


.service_auto_generate_title
{
    background-color:transparent ;
    font-size: 13px !important;
    font-weight: 100;
    padding: 5px;
    border-color: transparent;
    color: #2E4051 !important;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
}
.ibox{
    width: 100%;
    margin: 10px auto;
}



@media (min-width: 1350px) {
  .m-mobile-title {
    margin-bottom: 20px;
  }

}
@media (max-width: 1025px) {
    .ibox {
        width: 98%;
    }

}
@media (max-width: 769px) {
    .ibox {
        width: 102%;
        margin-left: -7px;
    }


    .title_data_mop{
        margin-left: 0px;
    }
    #save_form_and_checklist{
        width: 25%;
        float: right;
    }
}

@media (max-width: 425px) {
    .ibox {
        width: 102%;
    }
    .test{
        padding: 0px;
    }
    #save_form_and_checklist{
        width: 25%;
        float: right;
    }
    .padding-new-style-form-adn-checklist{
        padding-right: 30px !important;
        padding-left: 30px !important;
    }
}


.btn{
    padding: 6px 0px;
}

@media (max-width: 391px) {
    .ibox {
        width: 103% !important;
    }

    .test{
        padding: 0px;
    }
    .add_border_to_main_section{
        padding: 10px;
    }
    .btn{
        padding: 6px 0px;
    }

    .padding-new-style-form-adn-checklist{
        padding-right: 30px !important;
        padding-left: 30px !important;
    }

}


.three-dots-position-action:hover::before {
    content: '';
    position: absolute;
    left: 45%;
    top: 45%;
    transform: translate(-50%, -50%);
    width: 30px;
    height: 30px;
    background-color: rgba(128,128,128,0.3);
    border-radius: 50%;
    z-index: 0;
    color: black;
}
.three_dots_style:hover, .three_dots_style{
    display: block;
}

.btn-default {
    color: #333;
    background-color: #fff;
    border-color: #ccc;
}

.actions-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    padding: 0;
    width: 32px !important;
    height: 32px !important;
    line-height: 2.2 !important;
}

.btn-default:hover {
    color: #333;
    background-color: #e6e6e6;
    border-color: #adadad;
}

</style>